import { render, staticRenderFns } from "./AssignUserType.vue?vue&type=template&id=70e4dbe8&scoped=true"
import script from "./AssignUserType.vue?vue&type=script&lang=js"
export * from "./AssignUserType.vue?vue&type=script&lang=js"
import style0 from "./AssignUserType.vue?vue&type=style&index=0&id=70e4dbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4dbe8",
  null
  
)

export default component.exports